import React from 'react';
import { Box, Container, Paper } from '@mui/material';
import logoFull from '../../../assets/icons/main/el_logo_full.svg';

const AuthLayout = ({ children }) => {
    return (
        <Box 
            sx={{
                minHeight: '100vh',
                width: '100vw',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
                pt: '15vh'
            }}
        >
            <Container 
                component='main' 
                maxWidth={false}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    p: 2,
                    width: '100%'
                }}
            >
                <Box 
                    component="img"
                    src={logoFull}
                    alt="Elemental"
                    sx={{
                        height: '40px',
                        mb: 4,
                        opacity: 0.8
                    }}
                />
                <Paper 
                    elevation={0}
                    sx={{
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                        maxWidth: '600px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px'
                    }}
                >
                    <Box sx={{ width: '100%' }}>
                        {children}
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default AuthLayout; 